import { permissionGuard } from '../guards/permission.guard';

export const canUploadSelloutGuard = permissionGuard(
  'Sellout',
  'upload',
  'You are not authorized to upload sellouts.'
);
